import { windowProvider } from './windowProvider'

export const MOBILE_BREAKPOINT = '992px'
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT})`

export function isMobile(mediaQuery = MOBILE_MEDIA_QUERY): boolean {
  return matchMedia(mediaQuery)
}

export function matchMedia(mediaQuery: string): boolean {
  return windowProvider().matchMedia(mediaQuery).matches
}
